import React from "react";

import OfferIcon from "@components/icons/Offer";
import TopTournamentIcons from "@features/offer/shared/icon/TopTournamentMenuIcons";
import { BaseOfferMenuStore as OfferMenuStore } from "@state/stores/offer/shared/BaseOfferMenuStore";
import classNames from "classnames";
import { observer } from "mobx-react";

import { MenuSportItemButtonCount } from ".";
import { ToggleIndicator } from "..";

export const MenuSportItemButtonCore = observer(
	function MenuSportItemButtonCore(props: {
		sportMenuItem: OfferMenuStore["menu"];
		isSelected?: boolean;
	}) {
		const iconClass = classNames(
			"nav--secondary__icon__inner u-icon u-icon--lrg u-icon--sport u-icon--sport--color",
			{
				"is-selected": props.isSelected,
			}
		);

		return (
			<>
				{props.sportMenuItem.node.isTopTournament ? (
					<div className="nav--secondary__icon">
						<i
							className={
								"nav--sports__tag u-icon u-icon--big u-icon--rounded u-icon--top--str" +
								(props.isSelected
									? " is-selected u-color--core--snow"
									: " u-color--sent--danger")
							}
						/>

						<TopTournamentIcons
							tournamentAbrv={props.sportMenuItem.node.abrv || ""}
							className={iconClass}
							sportAbrv=""
						/>
					</div>
				) : (
					<div className="nav--secondary__icon">
						<MenuSportItemButtonCount
							sportMenuItem={props.sportMenuItem}
							isTopTournament={
								props.sportMenuItem.node.isTopTournament
							}
						/>

						<OfferIcon
							type="sport"
							sport={props.sportMenuItem.node.abrv || ""}
							className={iconClass}
							treeIcon={true}
						/>
					</div>
				)}

				<div className="nav--secondary__title">
					{props.sportMenuItem.node.name}
				</div>

				<ToggleIndicator
					sportMenuItem={props.sportMenuItem}
					isSelected={props.isSelected}
				/>
			</>
		);
	}
);
